const costData = [
  {
    system: "Solar Generator",
    icon: "ri-sun-line",
    accentColor: "text-amber-600",
    accentBg: "bg-amber-50",
    borderColor: "border-amber-200",
    items: [
      { label: "Unit Cost", range: "$500 – $5,000", note: "Portable station + solar panels" },
      { label: "Installation", range: "$0 – $200", note: "DIY-friendly setup" },
      { label: "Year 1 Fuel Cost", range: "$0", note: "Solar is free" },
      { label: "Annual Maintenance", range: "$0 – $50", note: "Minimal — no engine parts" },
      { label: "Battery Replacement (yr 8–12)", range: "$300 – $1,500", note: "Optional expansion modules" },
    ],
    fiveYear: "$700 – $5,500",
    fiveYearColor: "text-emerald-600",
    badge: "Best Long-Term Value",
    badgeBg: "bg-emerald-100 text-emerald-700",
  },
  {
    system: "Gas Generator",
    icon: "ri-oil-line",
    accentColor: "text-slate-600",
    accentBg: "bg-slate-50",
    borderColor: "border-slate-200",
    items: [
      { label: "Unit Cost", range: "$300 – $2,500", note: "Portable or semi-portable unit" },
      { label: "Installation", range: "$0 – $300", note: "Transfer switch recommended" },
      { label: "Annual Fuel Cost", range: "$150 – $600", note: "Based on usage during outages" },
      { label: "Annual Maintenance", range: "$100 – $300", note: "Oil, spark plugs, carb service" },
      { label: "Fuel Storage + Stabilizer", range: "$50 – $150/yr", note: "Safe fuel storage" },
    ],
    fiveYear: "$1,300 – $7,000",
    fiveYearColor: "text-amber-600",
    badge: "Lowest Upfront Cost",
    badgeBg: "bg-slate-100 text-slate-600",
  },
  {
    system: "Whole Home Standby",
    icon: "ri-building-2-line",
    accentColor: "text-slate-700",
    accentBg: "bg-slate-50",
    borderColor: "border-slate-200",
    items: [
      { label: "Unit Cost", range: "$3,000 – $15,000", note: "Depending on size (10kW–22kW)" },
      { label: "Installation", range: "$2,000 – $5,000", note: "Electrical permit + licensed install" },
      { label: "Annual Fuel Cost", range: "$200 – $800", note: "Natural gas during outages" },
      { label: "Annual Maintenance", range: "$200 – $500", note: "Professional service required" },
      { label: "Transfer Switch / Panel Work", range: "$500 – $1,500", note: "Usually included in install" },
    ],
    fiveYear: "$8,000 – $30,000+",
    fiveYearColor: "text-red-500",
    badge: "Highest Coverage",
    badgeBg: "bg-slate-100 text-slate-600",
  },
];

export default function CostBreakdown() {
  return (
    <section id="cost" className="py-20 bg-gray-900 scroll-mt-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="text-amber-400 text-xs font-bold uppercase tracking-widest">5-Year Total Cost</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mt-2 mb-3">
            True Cost of Ownership
          </h2>
          <p className="text-gray-400 text-base max-w-xl mx-auto">
            The sticker price is only part of the story. Here&apos;s what you&apos;re actually committing to over five years.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {costData.map((item) => (
            <div key={item.system} className="bg-white rounded-2xl overflow-hidden">
              {/* Header */}
              <div className={`px-6 py-5 ${item.accentBg} border-b ${item.borderColor}`}>
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-white rounded-xl">
                    <i className={`${item.icon} ${item.accentColor} text-lg`}></i>
                  </div>
                  <h3 className="font-extrabold text-gray-900 text-base">{item.system}</h3>
                </div>
                <span className={`inline-block text-xs font-bold px-2.5 py-1 rounded-full ${item.badgeBg}`}>
                  {item.badge}
                </span>
              </div>

              {/* Line items */}
              <div className="px-6 py-4 space-y-3">
                {item.items.map((line) => (
                  <div key={line.label} className="flex justify-between gap-3 items-start">
                    <div className="flex-1">
                      <p className="text-sm font-semibold text-gray-700">{line.label}</p>
                      <p className="text-xs text-gray-400 mt-0.5">{line.note}</p>
                    </div>
                    <span className="text-sm font-bold text-gray-900 whitespace-nowrap shrink-0">{line.range}</span>
                  </div>
                ))}
              </div>

              {/* 5-year total */}
              <div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
                <div className="flex justify-between items-center">
                  <p className="text-sm font-bold text-gray-700">5-Year Total (est.)</p>
                  <p className={`text-lg font-extrabold ${item.fiveYearColor}`}>{item.fiveYear}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-gray-500 text-xs mt-8 max-w-2xl mx-auto">
          Estimates based on average residential outage duration (4–20 hrs/yr), manufacturer pricing, and standard installation rates in the continental U.S.
          Actual costs vary by region, usage, and system configuration.
        </p>
      </div>
    </section>
  );
}
